export const engagementsTotalOrdersMapper = {
  NEW: 'New',
  RENEWAL: 'Renewal',
  RE_ORDER: 'Re-order',
  CANCELED: 'Canceled',
  CUSTOMER_ASSIST_OR_PM: 'Customer Assist/PM',
  CUSTOMER_ASSIST_OR_BILLING: 'Customer Assist/Billing',
};
